<template>
  <router-view class="toeic_main" :key="$route.fullPath"></router-view>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  export default {
    name: 'Layout',
    data () {
      return {
      }
    },
    watch: {
    },
    computed: {
      ...mapGetters([
        'remainPoints'
      ])
    },

    methods: {
      ...mapActions({
        doGetPoints: 'getRemainPoints'
      })
    }
  }
</script>
<style lang="scss" scoped>
.header {
  background-color: #166CB3;
}
.toeic_main {
  background-color: rgb(214, 224, 233);
  min-height: 100vh !important;
}
</style>
